/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SlideAdminPATCH = {
    case_id: number;
    lab_id: number;
    specimen_id: number | null;
    block_obj_id: number | null;
    stain_id: number;
    accession_prefix_id: number;
    /**
     * industry name for the extracted 'case id' value. Should match Case.accession
     */
    accession_number?: string | null;
    /**
     * selectable status field for QC slide tracking process
     */
    qc_status?: SlideAdminPATCH.qc_status | null;
    /**
     * operational or temporary notes from the quality control team
     */
    qc_notes?: string | null;
    /**
     * slide number in the provided block
     */
    slide_number?: string | null;
    is_rescan?: boolean;
    is_control?: boolean;
}

export namespace SlideAdminPATCH {

    /**
     * selectable status field for QC slide tracking process
     */
    export enum qc_status {
        CHECKED = 'checked',
        BLURRY = 'blurry',
        CONTACT_LAB = 'contact-lab',
        MISSING_LAB = 'missing-lab',
        MISSING_VIEWER = 'missing-viewer',
        MISLABELED = 'mislabeled',
        UNKNOWN = 'unknown',
    }


}
